/* src/app/account/digital-wallet/dw-rewardship/dw-rewardship-advanced-filter/dw-rewardship-advanced-filter.component.scss */
.filter-title {
  font-size: 2.5rem;
  font-weight: 400;
  position: relative;
}
.filter-title::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  bottom: -1.5rem;
  width: 4.5rem;
  height: 0.25rem;
  background-color: #ffb500;
}
section {
  margin-bottom: 1rem;
}
section .section-title {
  font-size: 1.25rem;
  font-weight: 600;
}
section .mat-mdc-form-field {
  width: 100%;
}
.date-range-types {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-bottom: 1rem;
}
.balance-inputs {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-between;
  column-gap: 1rem;
}
.balance-inputs .mat-form-field {
  flex: 1;
}
.slider-wrapper {
  margin-bottom: 3rem;
}
.slider-wrapper .mat-mdc-slider {
  width: 100%;
  position: relative;
}
.slider-wrapper .mat-mdc-slider::before,
.slider-wrapper .mat-mdc-slider::after {
  position: absolute;
  bottom: -0.75rem;
  font-size: 0.8rem;
}
.slider-wrapper .mat-mdc-slider::before {
  content: "$" var(--min-balance);
  left: -1em;
}
.slider-wrapper .mat-mdc-slider::after {
  content: "$" var(--max-balance);
  right: -1em;
}
.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 1rem;
}
.mdc-button {
  font-size: 0.8rem;
  height: 2.5rem;
  padding: 1rem 1.5rem;
}
.mdc-button.capsule {
  border-radius: 9999px;
}
.mdc-button[type=submit] {
  color: #121212;
  background-color: #ffb500;
  border-color: #ffb500;
}
.mdc-button[type=reset] {
  color: #0662BB;
  background-color: white;
  border-color: #0662BB;
}
:host(.dw-rewardship-advanced-filter) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=dw-rewardship-advanced-filter.component.css.map */
